import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { HeroSection } from './components/HeroSection';
import { ServicesSection } from './components/ServicesSection';
import { ExpertiseSection } from './components/ExpertiseSection';
import { AutomationSection } from './components/AutomationSection';
import { EcommerceSection } from './components/EcommerceSection';
import { WorkSection } from './components/WorkSection';
import { SupportSection } from './components/SupportSection';
import { TestimonialsSection } from './components/TestimonialsSection';
import { QuestionsSection } from './components/QuestionsSection';
import { ClosingSection } from './components/ClosingSection';
import { SiteFooter } from './components/SiteFooter';
import { usePageMeta } from './hooks/usePageMeta';
import { useContactAnchor } from './hooks/useContactAnchor';
export function App() {
  usePageMeta({
    title: 'WebsiteForge | Custom Websites & Business Systems',
    description: 'Custom websites, SEO, advertising, ecommerce, and business automation planned and managed by one experienced team.',
    robots: 'noindex,nofollow'
  });
  useContactAnchor();
  return <div className="min-h-screen w-full bg-paper font-sans text-ink" data-id="element-0" data-mp="3mj6ibtbzzuee">
      <a href="#main" className="sr-only focus:not-sr-only focus:fixed focus:left-4 focus:top-4 focus:z-50 focus:rounded-md focus:bg-paper focus:px-4 focus:py-2 focus:font-bold" data-id="element-1" data-mp="3rcsyhvhdegey">
        Skip to content
      </a>
      <SiteHeader data-id="element-2" data-mp="2znfy0adui2o6" />
      <main id="main" data-id="element-3" data-mp="33m5be2yvvk7t">
        <HeroSection data-id="element-4" data-mp="33nq4do5juv3k" />
        <ServicesSection data-id="element-5" data-mp="33n6w6z5pbl2q" />
        <ExpertiseSection data-id="element-6" data-mp="33oi152avuyvf" />
        <AutomationSection data-id="element-7" data-mp="38l8h7pmotugu" />
        <EcommerceSection data-id="element-8" data-mp="38l06o4e1f18t" />
        <WorkSection data-id="element-9" data-mp="38nuqput52k1p" />
        <SupportSection data-id="element-10" data-mp="3dkurprb4swly" />
        <TestimonialsSection data-id="element-11" data-mp="3dl4kfmnk9hvc" />
        <QuestionsSection data-id="element-12" data-mp="3dmfn1j59sjkv" />
        <ClosingSection data-id="element-13" data-mp="3dii694660445" />
      </main>
      <SiteFooter data-id="element-14" data-mp="nwc1psim5vw9" />
    </div>;
}